import axios from 'axios';
import { config } from '../components/pages/config';
import { AUTH_API } from '../components/pages/config';

export async function signIn(username, password) {
  try {
    const response = await fetch(`${AUTH_API}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: data.message || 'Error signing in.',
      };
    }
    
    localStorage.setItem('loggedInUser', username);
    localStorage.setItem('loggedInUserid', data.user_id);
    return {
      success: true,
      message: data.message || 'Signed in successfully',
      management_type: data.management_type || 'photographer',
      user_id: data.user_id,                //  ← NEW

    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Unknown error signing in.',
    };
  }
}


/**
 * Example isLoggedIn check: returns true if localStorage has 'loggedInUser'.
 */
export function isLoggedIn() {
  return Boolean(localStorage.getItem('loggedInUser'));
}

export async function signUp(username, email, phone, password, management_type = 'photographer') {
  const bodyData = {
    username,
    password,
    phone,
    management_type,
    email
  };

  try {
    const response = await fetch(`${AUTH_API}/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyData),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: data.message || 'Error signing up.',
      };
    }

    return {
      success: true,
      message: data.message || 'Signed up successfully',
      user_id: data.user_id || '',
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Unknown error signing up.',
    };
  }
}
  

// 👇 ADD these two functions underneath signUp()

export async function getUserDetails(user_id) {
  try {
    const res  = await fetch(`${AUTH_API}/get-user`, {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify({ user_id }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message);
    return { success: true, user: data.user };
  } catch (err) {
    return { success: false, message: err.message };
  }
}

export async function updatePhotographerProfile(userId, data) {
  try {
    const response = await fetch(`${AUTH_API}/update-profile`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    const result = await response.json();
    return { success: response.ok, ...result };
  } catch (err) {
    return { success: false, message: err.message };
  }
}
export async function uploadProfileImage(user_id, image_base64) {
  try {
    const res = await fetch(`${AUTH_API}/upload-profile-image`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id, image_base64 }),
    });
    const data = await res.json();
    return { success: res.ok, ...data };
  } catch (err) {
    return { success: false, message: err.message };
  }
}

